<template>
  <div>
    <div v-if="!loaded_review_data" class="row">
      <div class="col-12">
        <order_loader :loadingMessage="'Review CCO'"></order_loader>
      </div>
    </div>
    <div v-else>
      <div v-if="$store.state.orders.order_steps.publish_information.partial_order_complete">
      <div id="order_view_container">
        <div id="order_view">

          <div id="order_header">
            <img id="order_header_logo" v-if="crmCompany === 'Genius Money'" src="/img/logos/payroll/genius_logo_dark.svg" alt="Payroll CRM Logo">
            <img id="order_header_logo" v-if="crmCompany === 'V3 Recruitment'" src="/img/logos/recruitment/v3_logo_dark.svg" alt="Recruitment CRM Logo">
            <img id="order_header_logo" v-if="crmCompany === 'Build People'" src="/img/logos/build_people/bp_logo.svg" alt="Build People CRM Logo">
          </div>

          <div id="order_title">
            <table class="w-100">
              <tr>
                <td>
                  <h3 id="order_title_cco">CLIENT CONFIRMATION ORDER</h3>
                  <h4 id="order_title_company">{{ basic_info.company.company_name }}</h4>
                </td>
              </tr>
            </table>
          </div>

          <div class="order_body">
            <table class="w-100">
              <tr>
                <td class="value twoCol blank_bg">
                  <table class="w-100">
                    <tr>
                      <td class="field">Order Type&nbsp;:</td>
                      <td class="value">{{ basic_info.type.value }}</td>
                    </tr>
                    <tr>
                      <td class="field">Date Order Raised&nbsp;:</td>
                      <td class="value">{{ basic_info.date_of_order | formatDate }}</td>
                    </tr>
                    <tr>
                      <td class="field">Consultant&nbsp;:</td>
                      <td class="value twoCol">{{ basic_info.consultant.first_name }} {{ basic_info.consultant.surname }}</td>
                    </tr>
                    <tr v-if="basic_info?.payroll_solution && basic_info.payroll_solution?.value">
                      <td class="field">Solution&nbsp;:</td>
                      <td class="value">{{ basic_info.payroll_solution.value }}</td>
                    </tr>
                    <tr v-if="basic_info?.payroll_solution && basic_info.project_manager && basic_info.payroll_solution?.value === 'Project Managed Labour Solutions'">
                      <td class="field">Project Manager&nbsp;:</td>
                      <td class="value">{{ basic_info.project_manager?.first_name }} {{ basic_info.project_manager?.surname }}</td>
                    </tr>
                  </table>
                </td>
                <td class="value twoCol blank_bg">
                  <table class="w-100">
                    <tr>
                      <td>
                        <div class="order_status_container">
                          <div class="order_status" :class="basic_info.status === 'Live' ? 'live_order' : ''">
                            <span id="o_status" :class="basic_info.status === 'Live' ? 'live_order' : ''">{{ basic_info.status }}</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>

            <table class="w-100 mt-4" style="padding-left: 10px; padding-right: 10px;">
              <tr>
                <td>
                  <p class="text-justify">Dear {{ basic_info.job_contact.person.first_name }} {{ basic_info.job_contact.person.surname }}</p>
                  <p class="text-justify">Please find below confirmation of your order for labour together with Terms of Business, together these form part of the agreed Contract
                    between {{ crmCompany }} and you as the client.<br>
                    Any previously agreed Terms of Business between both parties will continue to apply. In the event of any conflict between this order and the Terms of Business,
                    the terms as outlined in this order prevail.</p>
                </td>
              </tr>
            </table>

            <div class="order_box" v-for="loc in parseInt(job_locations.number_of_sites)">
              <button class="order_loc bp_color text-uppercase" href="#" v-b-toggle="'accordion-' + loc">{{ job_locations.site[loc].short_site_name }}</button>

              <b-collapse :id="'accordion-' + loc" accordion="my-accordion">
                <!-- Location Address / Main Contractor / Build Type / VAT Treatment -->
                <table class="w-100 mb-3">
                  <!-- Location Address -->
                  <tr>
                    <td class="field">Location Address&nbsp;:</td>
                    <td class="value" colspan="3">{{
                        calc_nice_address(job_locations.site[loc].address.address_building, job_locations.site[loc].address.address_street,
                            job_locations.site[loc].address.address_locality, job_locations.site[loc].address.address_city_town, job_locations.site[loc].address.address_county,
                            job_locations.site[loc].address.address_postcode)
                      }}
                    </td>
                  </tr>
                  <!-- Main Contractor / VAT Treatment -->
                  <tr v-if="basic_info.type.value === 'Contract'">
                    <td class="field">Site Main Contractor&nbsp;:</td>
                    <td class="value">{{ job_locations.site[loc].site_main_contractor }}</td>
                  </tr>
                  <tr v-if="job_locations?.site[loc]?.site_vat_treatment">
                    <td class="field">Site VAT Treatment&nbsp;:</td>
                    <td class="value twoCol">{{ job_locations.site[loc].site_vat_treatment.value }}</td>
                  </tr>
                </table>

                <div class="order_box blank_bg" v-for="pos in parseInt(positions_rates.number_of_positions)"
                     v-if="positions_rates.position[pos].locations.includes(job_locations.site[loc].short_site_name)">

                  <button class="order_loc text-uppercase" href="#" v-b-toggle="'accordion-2' + loc + '-' + pos">
                    <h2 class="text-uppercase position_title">{{ positions_rates.position[pos].job_title.job_title }}</h2>
                    <h2 class="text-uppercase position_published float-right" v-for="pub_info in publish_information">
                     <span v-for="pi in pub_info"
                           v-if="job_locations.site[loc].short_site_name === pi.location && positions_rates.position[pos].job_title.job_title === pi.job_title.job_title">
                      <span class="pp_true" v-if="pi.order_published">PUBLISHED</span>
                      <span class="pp_false" v-else>NOT PUBLISHED</span>
                     </span>
                    </h2>
                  </button>

                  <b-collapse :id="'accordion-2' + loc + '-' + pos" accordion="my-accordion2">
                    <div v-for="spec in positions_rates.position[pos].location_specs" v-if="job_locations.site[loc].short_site_name === spec.location">
                      <table class="w-100">
                        <tr>
                          <td class="field">Workers Required&nbsp;:</td>
                          <td class="value" colspan="3">{{ spec.position_info.quantity }}</td>
                        </tr>
                        <tr>
                          <td class="field">Start Date&nbsp;:</td>
                          <td class="value twoCol">{{ spec.position_info.start_date | formatDate }}</td>
                          <td v-if="basic_info.type.value !== 'Permanent' && basic_info.type.value !== 'Internal'" class="field">End Date&nbsp;:</td>
                          <td v-else class="field"></td>
                          <td v-if="basic_info.type.value !== 'Permanent' && basic_info.type.value !== 'Internal'" class="value twoCol">{{ spec.position_info.end_date | formatDate }}</td>
                          <td v-else class="value twoCol blank_bg"></td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <hr>
                          </td>
                        </tr>
                        <tr>
                          <td class="field">Days worked in week&nbsp;:</td>
                          <td class="value" colspan="3">
                           <span v-for="day in spec.position_info.working_week">
                            <span v-if="spec.position_info.working_week.length -1 !== spec.position_info.working_week.indexOf(day)">
                              {{ day.replace('work_', '') | capitalWords }}, </span>
                            <span v-else>{{ day.replace('work_', '') | capitalWords }}</span>
                           </span>
                          </td>
                        </tr>
                        <tr>
                          <td class="field">Start Time&nbsp;:</td>
                          <td class="value twoCol">{{ spec.position_info.start_time }}</td>
                          <td class="field">End Time&nbsp;:</td>
                          <td class="value twoCol">{{ spec.position_info.end_time }}</td>
                        </tr>
                        <tr>
                          <td class="field">Lunch Length&nbsp;:</td>
                          <td class="value twoCol">{{ spec.position_info.lunch_length }}</td>
                          <td class="field">Lunch Paid&nbsp;:</td>
                          <td class="value twoCol">
                            <span v-if="spec.position_info.lunch_paid">Yes</span>
                            <span v-if="!spec.position_info.lunch_paid">No</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="field">Hours in week&nbsp;:</td>
                          <td class="value" colspan="3">{{ calc_total_max_hours(spec.position_info.total_hours, spec.position_info.working_week) }}</td>
                        </tr>
                        <!-- Reports to -->
                        <tr>
                          <td colspan="4">
                            <hr class="mb-1">
                          </td>
                        </tr>
                        <tr>
                          <td class="field" colspan="4"><h5 class="text-uppercase" style="color: #333333;">Worker Reports To</h5></td>
                        </tr>
                        <tr>
                          <td class="field">Name&nbsp;:</td>
                          <td class="value twoCol">{{ spec.position_info.reports_to.person.first_name }} {{ spec.position_info.reports_to.person.surname }}</td>
                          <td class="field">Job Title&nbsp;:</td>
                          <td class="value twoCol">
                            <span v-if="spec.position_info.reports_to.rel_profile.job_title_id !== null">{{ spec.position_info.reports_to.rel_profile.job_title.job_title }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="field">Landline&nbsp;:</td>
                          <td class="value twoCol">{{ spec.position_info.reports_to.phones.work_landline }}</td>
                          <td class="field">Mobile&nbsp;:</td>
                          <td class="value twoCol">{{ spec.position_info.reports_to.phones.work_mobile }}</td>
                        </tr>
                        <tr>
                          <td class="field">Email&nbsp;:</td>
                          <td class="value" colspan="3">{{ spec.position_info.reports_to.emails.work_email }}</td>
                        </tr>
                        <!-- Position Information -->
                        <tr>
                          <td colspan="4">
                            <hr class="mb-1">
                          </td>
                        </tr>
                        <tr>
                          <td class="field" colspan="4"><h5 class="text-uppercase" style="color: #333333;">Position Information</h5></td>
                        </tr>
                        <tr v-if="spec.position_info.essential_qualifications !== null">
                          <td class="field">Essential Qualifications</td>
                          <td class="value" colspan="3">
                            <span v-for="eq in spec.position_info.essential_qualifications">
                            <span v-if="spec.position_info.essential_qualifications.length -1 !== spec.position_info.essential_qualifications.indexOf(eq)">
                              {{ eq.qualification }}, </span>
                            <span v-else>{{ eq.qualification }}</span>
                           </span>
                          </td>
                        </tr>
                        <tr v-if="spec.position_info.key_responsibilities !== null && spec.position_info.key_responsibilities !== ''">
                          <td class="field">Key Responsibilities</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.key_responsibilities }}</pre>
                          </td>
                        </tr>
                        <tr v-if="spec.position_info.job_brief !== null && spec.position_info.job_brief !== ''">
                          <td class="field">Job Brief</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.job_brief }}</pre>
                          </td>
                        </tr>
                        <tr v-if="spec.position_info.key_skills_experience !== null && spec.position_info.key_skills_experience !== ''">
                          <td class="field">Key Skills / Experience</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.key_skills_experience }}</pre>
                          </td>
                        </tr>
                        <tr v-if="basic_info.type.value === 'Contract' && spec.position_info.health_and_safety !== null && spec.position_info.health_and_safety !== ''">
                          <td class="field">Known Health & Safety Risks</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.health_and_safety }}</pre>
                          </td>
                        </tr>
                        <tr v-if="basic_info.type.value === 'Contract' && spec.position_info.ppe_tools !== null && spec.position_info.ppe_tools !== ''">
                          <td class="field">PPE / Tools Required</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.ppe_tools }}</pre>
                          </td>
                        </tr>
                        <tr v-if="spec.position_info.additional_details !== null && spec.position_info.additional_details !== ''">
                          <td class="field">Additional Assignment Details</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.additional_details }}</pre>
                          </td>
                        </tr>
                      </table>
                      <!-- Rates -->
                      <table class="w-100" v-if="basic_info.type.value !== 'Permanent'">
                        <tr>
                          <td colspan="4">
                            <hr class="mb-1">
                          </td>
                        </tr>
                        <tr>
                          <td class="field" colspan="4"><h5 class="text-uppercase mb-0" style="color: #333333;">Rates, Fees & Retention</h5></td>
                        </tr>
                      </table>
                      <table class="w-100" v-if="spec?.position_info?.recruitment_margin_perc">
                        <tr>
                          <td class="field">Recruitment Margin</td>
                          <td class="value twoCol">{{spec.position_info.recruitment_margin_perc | percentage}}</td>
                          <td class="field"></td>
                          <td class="value twoCol blank_bg"></td>
                        </tr>
                      </table>
                      <div v-for="(r, i) in spec.position_info.rate" v-if="notEmptyObject(r) && basic_info.type.value !== 'Permanent'">
                        <table class="w-100">
                          <tr>
                            <td class="field" colspan="4"><h5 class="mb-0">Rate {{ i }}</h5></td>
                          </tr>
                          <tr>
                            <td class="field">Rate Type&nbsp;:</td>
                            <td class="value twoCol">{{ r.type.value }}</td>
                            <td class="field">Pay Type&nbsp;:</td>
                            <td class="value twoCol">{{ r.pay_type.value }}</td>
                          </tr>
                          <tr>
                            <td class="field">Pay Amount&nbsp;:</td>
                            <td class="value twoCol">{{ r.pay_amount | currency }}</td>
                            <td class="field"
                                v-if="
                                    basic_info.type.value === 'Temporary (PAYE)' ||
                                    basic_info.type.value === 'Contract' ||
                                    basic_info.type.value  === 'Payroll - PAYE' ||
                                    basic_info.type.value === 'Temporary (PAYE)'
                              ">Charge Rate&nbsp;:
                            </td>
                            <td class="field" v-else>Admin Fee&nbsp;:</td>
                            <td class="value twoCol">
                              <span v-if="r.admin_fee_type.value === '£ (Pound)'">{{ r.admin_fee | currency }}</span>
                              <span v-if="r.admin_fee_type.value === '% (Percentage)'">{{ r.admin_fee | percentage }}</span>
                            </td>
                          </tr>
                          <tr v-if="
                              basic_info.type.value !== 'Temporary (PAYE)' &&
                              basic_info.type.value !== 'Payroll - PAYE' &&
                              basic_info.type.value !== 'Permanent'">
                            <td class="field"></td>
                            <td class="value twoCol blank_bg"></td>
                            <td class="field">Retention&nbsp;:</td>
                            <td class="value twoCol">{{ r.retention_percentage | percentage }}</td>
                          </tr>
                        </table>
                      </div>
                      <table class="w-100" v-if="basic_info.type.value === 'Permanent'">
                        <tr>
                          <td colspan="4">
                            <hr class="mb-1">
                          </td>
                        </tr>
                        <tr>
                          <td class="field" colspan="4"><h5 class="text-uppercase" style="color: #333333;">Package Information</h5></td>
                        </tr>
                        <!-- Pension -->
                        <tr>
                          <td class="field">Percentage Percentage</td>
                          <td class="value twoCol">{{spec.position_info.perm_details.pension_percentage | percentage}}</td>
                          <td class="field">Percentage included in charge</td>
                          <td class="value twoCol blank_bg">
                            <span v-if="spec.position_info.perm_details.pension_included_in_charge">Yes</span>
                            <span v-else>No</span>
                          </td>
                        </tr>
                        <!-- Bonus -->
                        <tr v-if="spec.position_info.perm_details.bonus">
                          <td class="field">How bonus calculated</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.perm_details.bonus_how_calculated }}</pre>
                          </td>
                        </tr>
                        <tr v-if="spec.position_info.perm_details.bonus">
                          <td class="field">When bonus paid</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.perm_details.bonus_when_paid }}</pre>
                          </td>
                        </tr>
                        <tr v-if="spec.position_info.perm_details.bonus">
                          <td class="field">Bonus amount per annum</td>
                          <td class="value twoCol">{{spec.position_info.perm_details.bonus_amount_per_annum | currency}}</td>
                          <td class="field">Bonus included in charge</td>
                          <td class="value twoCol blank_bg">
                            <span v-if="spec.position_info.perm_details.bonus_included_in_charge">Yes</span>
                            <span v-else>No</span>
                          </td>
                        </tr>
                        <!-- Car allowance -->
                        <tr v-if="spec.position_info.perm_details.car_allowance">
                          <td class="field">Car make/model</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.perm_details.car_allowance_make_model }}</pre>
                          </td>
                        </tr>
                        <tr v-if="spec.position_info.perm_details.car_allowance">
                          <td class="field">Car allowance per annum</td>
                          <td class="value twoCol">{{spec.position_info.perm_details.car_allowance_amount_per_annum | currency}}</td>
                          <td class="field">Car allowance included in charge</td>
                          <td class="value twoCol blank_bg">
                            <span v-if="spec.position_info.perm_details.car_allowance_included_in_charge">Yes</span>
                            <span v-else>No</span>
                          </td>
                        </tr>
                        <!-- Health care type -->
                        <tr v-if="spec.position_info.perm_details.health_care">
                          <td class="field">Health care type</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.perm_details.health_care_type }}</pre>
                          </td>
                        </tr>
                        <tr v-if="spec.position_info.perm_details.health_care">
                          <td class="field">Health care amount per annum</td>
                          <td class="value twoCol">{{spec.position_info.perm_details.health_care_amount_per_annum | currency}}</td>
                          <td class="field">Health care included in charge</td>
                          <td class="value twoCol blank_bg">
                            <span v-if="spec.position_info.perm_details.health_care_included_in_charge">Yes</span>
                            <span v-else>No</span>
                          </td>
                        </tr>
                        <!-- Other Benefits Description -->
                        <tr v-if="spec.position_info.perm_details.any_other_benefits">
                          <td class="field">Other Benefits Description</td>
                          <td class="value" colspan="3">
                            <pre>{{ spec.position_info.perm_details.any_other_benefits_description }}</pre>
                          </td>
                        </tr>
                        <tr v-if="spec.position_info.perm_details.any_other_benefits">
                          <td class="field">Other benefits amount per annum</td>
                          <td class="value twoCol">{{spec.position_info.perm_details.any_other_benefits_amount_per_annum | currency}}</td>
                          <td class="field">Other benefits included in charge</td>
                          <td class="value twoCol blank_bg">
                            <span v-if="spec.position_info.perm_details.any_other_benefits_included_in_charge">Yes</span>
                            <span v-else>No</span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <hr class="mb-1">
                          </td>
                        </tr>
                        <tr>
                          <td class="field" colspan="4"><h5 class="text-uppercase" style="color: #333333;">Salary Range</h5></td>
                        </tr>
                        <tr>
                          <td class="field">Salary range start</td>
                          <td class="value twoCol">{{spec.position_info.perm_details.salary_range_start | currency}}</td>
                          <td class="field">Salary range end</td>
                          <td class="value twoCol">{{spec.position_info.perm_details.salary_range_end | currency}}</td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <hr class="mb-1">
                          </td>
                        </tr>
                        <tr>
                          <td class="field" colspan="3">
                            <h5 class="text-uppercase" style="color: #333333;">Total package amount</h5>
                          </td>
                          <td class="value">{{total_package_amount(spec) | currency}}</td>
                        </tr>
                        <tr>
                          <td class="field" colspan="4"><p style="color: #333333;">Total package for the worker including all add-ons to basic salary (Highest salary used in calculation)</p></td>
                        </tr>
                        <tr>
                          <td class="field" colspan="3">
                            <h5 class="text-uppercase" style="color: #333333;">Recruitment Fee</h5>
                          </td>
                          <td class="value">{{spec.position_info.rate[1].admin_fee | currency}}</td>
                        </tr>
                      </table>

                      <!--          <table v-if="basic_info.type === 'Temporary (PAYE)'" class="w-100">-->
                      <!--           &lt;!&ndash; DRCE &ndash;&gt;-->
                      <!--           <tr>-->
                      <!--            <td colspan="4">-->
                      <!--             <hr class="mb-1">-->
                      <!--            </td>-->
                      <!--           </tr>-->
                      <!--           <tr>-->
                      <!--            <td class="field" colspan="4"><h5 class="text-uppercase mb-0" style="color: #333333;">DIRECT RECRUIT / COMPARABLE EMPLOYEE</h5></td>-->
                      <!--           </tr>-->
                      <!--           <tr>-->
                      <!--            <td class="moo_field" colspan="3">Does the Job Title and/or Job Duties exist already within the company? And Does the temp role within this order also have the-->
                      <!--             potential to last 12 weeks or longer?-->
                      <!--            </td>-->
                      <!--            <td class="moo_value">No</td>-->
                      <!--           </tr>-->
                      <!--           <tr>-->
                      <!--            <td colspan="4">-->
                      <!--             <table class="w-100">-->
                      <!--              <tr>-->
                      <!--               <td class="field">Basic Salary (£)</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--               <td class="field">Basic Hours&nbsp;:</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--              </tr>-->
                      <!--              <tr>-->
                      <!--               <td class="field">Rest Periods</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--               <td class="field">Lunch Break&nbsp;:</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--              </tr>-->
                      <!--              <tr>-->
                      <!--               <td class="field">Overtime Payments</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--               <td class="field">Shift Allowance&nbsp;:</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--              </tr>-->
                      <!--              <tr>-->
                      <!--               <td class="field">Commission</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--               <td class="field">Annual Leave Entitlement&nbsp;:</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--              </tr>-->
                      <!--              <tr>-->
                      <!--               <td class="field">Monetary Benefits</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--               <td class="field">Pension Contribution&nbsp;:</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--              </tr>-->
                      <!--              <tr>-->
                      <!--               <td class="field">Facilities</td>-->
                      <!--               <td class="value twoCol"></td>-->
                      <!--               <td class="field"></td>-->
                      <!--               <td class="value twoCol blank_bg"></td>-->
                      <!--              </tr>-->
                      <!--             </table>-->
                      <!--            </td>-->
                      <!--           </tr>-->
                      <!--           &lt;!&ndash; Position Terms &ndash;&gt;-->
                      <!--           <tr>-->
                      <!--            <td colspan="4">-->
                      <!--             <hr class="mb-1">-->
                      <!--            </td>-->
                      <!--           </tr>-->
                      <!--           <tr>-->
                      <!--            <td class="field" colspan="4"><h5 class="text-uppercase mb-0" style="color: #333333;">Position Terms</h5></td>-->
                      <!--           </tr>-->
                      <!--           <tr>-->
                      <!--            <td class="field">Client Ref/PO</td>-->
                      <!--            <td class="value" colspan="3"></td>-->
                      <!--           </tr>-->
                      <!--           <tr>-->
                      <!--            <td class="field">Term Amendments for Position</td>-->
                      <!--            <td class="value" colspan="3"></td>-->
                      <!--           </tr>-->
                      <!--           &lt;!&ndash; Timesheet Authorisation &ndash;&gt;-->
                      <!--           <tr>-->
                      <!--            <td colspan="4">-->
                      <!--             <hr class="mb-1">-->
                      <!--            </td>-->
                      <!--           </tr>-->
                      <!--           <tr>-->
                      <!--            <td class="field" colspan="4"><h5 class="text-uppercase mb-0" style="color: #333333;">Timesheet Authorisation</h5></td>-->
                      <!--           </tr>-->
                      <!--           <tr>-->
                      <!--            <td class="field" colspan="2">Timesheet Client Contact Authorisation procedure</td>-->
                      <!--            <td class="value" colspan="2"></td>-->
                      <!--           </tr>-->
                      <!--          </table>-->
                    </div>

                  </b-collapse>
                </div>
              </b-collapse>
            </div>

            <!-- Mutuality of obligation -->
            <div v-if="basic_info.type.value === 'Contract'" class="order_box">
              <h4 class="text-uppercase">Mutuality of obligation</h4>

              <table class="w-100">
                <tr>
                  <td class="moo_field">Is the worker subject to any supervision, direction or control?</td>
                  <td class="moo_value">
                    <span v-if="compliance_terms.moo.sdc">Yes</span>
                    <span v-if="!compliance_terms.moo.sdc">No</span>
                  </td>
                </tr>
                <tr>
                  <td class="moo_field">Can the worker decline the request to be moved from job to job?</td>
                  <td class="moo_value">
                    <span v-if="compliance_terms.moo.worker_decline_job_movement">Yes</span>
                    <span v-if="!compliance_terms.moo.worker_decline_job_movement">No</span>
                  </td>
                </tr>
                <tr>
                  <td class="moo_field">Once this contract is completed are you (the end user) under any obligation to offer further work?</td>
                  <td class="moo_value">
                    <span v-if="compliance_terms.moo.end_user_offer_further_work">Yes</span>
                    <span v-if="!compliance_terms.moo.end_user_offer_further_work">No</span>
                  </td>
                </tr>
                <tr>
                  <td class="moo_field">Once this contract is completed is the worker under any obligation to accept additional work offered?</td>
                  <td class="moo_value">
                    <span v-if="compliance_terms.moo.worker_accept_further_work">Yes</span>
                    <span v-if="!compliance_terms.moo.worker_accept_further_work">No</span>
                  </td>
                </tr>
                <tr>
                  <td class="moo_field">Does the worker have the freedom to choose how the work is to be performed?</td>
                  <td class="moo_value">
                    <span v-if="compliance_terms.moo.how_work_performed">Yes</span>
                    <span v-if="!compliance_terms.moo.how_work_performed">No</span>
                  </td>
                </tr>
                <tr>
                  <td class="moo_field">Is the worker responsible for the standard of their own work?</td>
                  <td class="moo_value">
                    <span v-if="compliance_terms.moo.responsible_work_standard">Yes</span>
                    <span v-if="!compliance_terms.moo.responsible_work_standard">No</span>
                  </td>
                </tr>
                <tr>
                  <td class="moo_field">Does the worker carry financial risk in relation to any work completed? (Especially substandard work)</td>
                  <td class="moo_value">
                    <span v-if="compliance_terms.moo.carry_financial_risk">Yes</span>
                    <span v-if="!compliance_terms.moo.carry_financial_risk">No</span>
                  </td>
                </tr>
              </table>
            </div>
            <!-- Payment Information / Accounts Contact / Authorise Terms Contact -->
            <table class="w-100 mt-4">
              <tr>
                <td class="field" colspan="4"><h4 class="text-uppercase" style="color: #333333;">Payment Information</h4></td>
              </tr>
              <tr>
                <td class="field">Invoice Address</td>
                <td class="value" colspan="3">{{ timesheet_authorisation.invoice_address.full }}</td>
              </tr>
              <tr>
                <td class="field">Payment Terms</td>
                <td class="value" colspan="3">{{ timesheet_authorisation.days_to_pay_from_invoice }} Days from Invoice</td>
              </tr>
              <!-- Accounts Contact -->
              <tr>
                <td colspan="4">
                  <hr class="mb-1">
                </td>
              </tr>
              <tr>
                <td class="field" colspan="4"><h4 class="text-uppercase" style="color: #333333;">Accounts Contact</h4></td>
              </tr>
              <tr>
                <td class="field">Name&nbsp;:</td>
                <td class="value twoCol">{{ timesheet_authorisation.accounts_contact.person.first_name }} {{ timesheet_authorisation.accounts_contact.person.surname }}</td>
                <td class="field">Job Title&nbsp;:</td>
                <td class="value twoCol">
                  <span v-if="timesheet_authorisation.accounts_contact.rel_profile.job_title_id !== null">
                    {{ timesheet_authorisation.accounts_contact.rel_profile.job_title.job_title }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="field">Landline&nbsp;:</td>
                <td class="value twoCol">{{ timesheet_authorisation.accounts_contact.phones.work_landline }}</td>
                <td class="field">Mobile&nbsp;:</td>
                <td class="value twoCol">{{ timesheet_authorisation.accounts_contact.phones.work_mobile }}</td>
              </tr>
              <tr>
                <td class="field">Email&nbsp;:</td>
                <td class="value" colspan="3">{{ timesheet_authorisation.accounts_contact.emails.work_email }}</td>
              </tr>
              <!-- Authorise Terms Contact -->
              <tr>
                <td colspan="4">
                  <hr class="mb-1">
                </td>
              </tr>
              <tr>
                <td class="field" colspan="4"><h4 class="text-uppercase" style="color: #333333;">Authorise Terms Contact</h4></td>
              </tr>
              <tr>
                <td class="field">Name&nbsp;:</td>
                <td class="value twoCol">{{ compliance_terms.auth_terms_contact.person.first_name }} {{ compliance_terms.auth_terms_contact.person.surname }}</td>
                <td class="field">Job Title&nbsp;:</td>
                <td class="value twoCol">
                  <span v-if="compliance_terms.auth_terms_contact.rel_profile.job_title_id !== null">
                    {{ compliance_terms.auth_terms_contact.rel_profile.job_title.job_title }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="field">Landline&nbsp;:</td>
                <td class="value twoCol">{{ compliance_terms.auth_terms_contact.phones.work_landline }}</td>
                <td class="field">Mobile&nbsp;:</td>
                <td class="value twoCol">{{ compliance_terms.auth_terms_contact.phones.work_mobile }}</td>
              </tr>
              <tr>
                <td class="field">Email&nbsp;:</td>
                <td class="value" colspan="3">{{ compliance_terms.auth_terms_contact.emails.work_email }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      </div>
      <div v-else class="row">
        <div class="col-12">
          <h5 class="red_color">You must complete all previous sections first before you can review this CCO.</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import order_loader from "loaders/order_loader";

export default {
  name: "review_order",
  components: {
    order_loader
  },
  data() {
    return {
      loaded_review_data: false,

      basic_info: {},
      job_locations: {},
      positions_rates: {},
      timesheet_authorisation: {},
      compliance_terms: {},
      publish_information: {}
    }
  },
  beforeMount() {
    this.load_data().then(() => this.loaded_review_data = true);
  },
  methods: {
    load_data() {
      return new Promise(resolve => {
        if (this.$store.state.orders.order_steps.basic_info.partial_order_complete) {
          this.basic_info = this.$store.state.orders.order_steps.basic_info.data;
        }
        if (this.$store.state.orders.order_steps.job_locations.partial_order_complete) {
          this.job_locations = this.$store.state.orders.order_steps.job_locations.data;
          for (let i = 1; i < this.job_locations.number_of_sites; i++) {
            this.job_locations.site[i]['expanded'] = false;
          }
        }
        if (this.$store.state.orders.order_steps.positions_rates.partial_order_complete) {
          this.positions_rates = this.$store.state.orders.order_steps.positions_rates.data;
          for (let i = 1; i < this.positions_rates.number_of_positions; i++) {
            this.positions_rates.position[i]['expanded'] = false;
          }
        }
        if (this.$store.state.orders.order_steps.timesheet_authorisation.partial_order_complete) {
          this.timesheet_authorisation = this.$store.state.orders.order_steps.timesheet_authorisation.data;
        }
        if (this.$store.state.orders.order_steps.compliance_terms.partial_order_complete) {
          this.compliance_terms = this.$store.state.orders.order_steps.compliance_terms.data;
        }
        if (this.$store.state.orders.order_steps.publish_information.partial_order_complete) {
          this.publish_information = this.$store.state.orders.order_steps.publish_information.data;
        }

        resolve();
      });
    },
    calc_total_max_hours(total_hours, week) {
      let week_without_bank_hol = week.filter(function (val) { return val !== 'work_bank_holiday' });
      return parseFloat(total_hours) * parseInt(week_without_bank_hol.length);
    },
    total_package_amount(spec) {
      let h_salary = 0, pension = 0, bonus = 0, car_allowance = 0, health_care = 0, other = 0;

      h_salary = parseFloat(spec.position_info.perm_details.salary_range_end)
      pension = parseFloat(spec.position_info.perm_details.pension_percentage)
      if (spec.position_info.perm_details.bonus) {
        bonus = parseFloat(spec.position_info.perm_details.bonus_amount_per_annum)
      }
      if (spec.position_info.perm_details.car_allowance) {
        car_allowance = parseFloat(spec.position_info.perm_details.car_allowance_amount_per_annum)
      }
      if (spec.position_info.perm_details.health_care) {
        health_care = parseFloat(spec.position_info.perm_details.car_allowance_amount_per_annum)
      }
      if (spec.position_info.perm_details.any_other_benefits) {
        other = parseFloat(spec.position_info.perm_details.any_other_benefits_amount_per_annum)
      }

      return h_salary + (h_salary * (pension / 100)) + bonus + car_allowance + health_care + other;
    }
  }
}
</script>

<style scoped lang="scss">
#order_view_container {
  max-width:    1151px !important;
  margin-right: auto;
  margin-left:  auto;

  #order_view {
    font-size:     0.9rem;
    background:    #fefefe;
    margin-bottom: 0;
    box-shadow:    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
    border:        1px solid #cccccc;

    #order_header {
      background:                 $bc_1 !important;
      display:                    block;
      height:                     65px;
      width:                      100%;
      margin-bottom:              15px;
      color-adjust:               exact;
      -webkit-print-color-adjust: exact;
      print-color-adjust:         exact;

      #order_header_logo {
        width:         100px;
        height:        100px;
        border:        3px solid $white;
        border-radius: $logo_border_radius;
        margin-left:   25px;
        margin-top:    15px;
      }
    }

    #order_title {
      padding:       0 20px;
      text-align:    right;
      margin-bottom: 20px;

      #order_title_cco {
        font-size:     1.95rem;
        color:         $bc_1;
        margin-bottom: 0;
      }

      #order_title_company {
        margin-bottom: 0;
        font-size:     1.65rem;
      }
    }

    .order_body {
      padding:       0 20px;
      margin-bottom: 20px;
      width:         100%;

      .order_box {
        padding:          10px 15px;
        background-color: lighten($bc_5, 18.5%);
        border:           1px solid lighten($bc_5, 12%);
        border-radius:    7px;
        margin-bottom:    20px;

        &.blank_bg {
          background-color: $white;
        }

        .order_loc {
          background:  transparent;
          font-size:   1.6rem;
          font-weight: bold;

          display:     block;
          width:       100%;
          border:      none;
          padding:     0;
          text-align:  left;

          &:hover, &:focus, &:active, &:active:focus, &.active:focus,
          &.focus, &:active.focus, &.active.focus {
            outline: none;
          }
        }
      }

      table {
        border-collapse: separate;
        border-spacing:  0 7.5px;
      }

      pre {
        font-family:   $font-family-header;
        margin-bottom: 5px;
        margin-top:    5px;
        color:         $bc_3;
        font-size:     0.9rem;
      }

      .position_title {
        display: inline-block;
      }

      .position_published {
        display: inline-block;

        .pp_true {
          color: $green;
        }

        .pp_false {
          color: $red;
        }
      }

      .field, .value, .moo_field, .moo_value {
        height:         35px;
        vertical-align: middle;
      }

      .field, .moo_field {
        /*font-weight:   bold;*/
        color:         $bc_3;
        padding-left:  10px;
        padding-right: 5px;
      }

      .field {
        width: 170px;

        &.twoCol {
          padding-left: 10px;
        }
      }

      .value, .moo_value {
        background:                 lighten($bc_5, 15%);
        border-radius:              $border_radius;
        padding-left:               10px;
        padding-right:              10px;
        color:                      $bc_3;
        color-adjust:               exact;
        -webkit-print-color-adjust: exact;
        print-color-adjust:         exact;
      }

      .value {
        &.twoCol {
          width: 276px !important;
        }

        &.blank_bg {
          background: transparent;
        }
      }

      .moo_value {
        width:      80px;
        text-align: center;
      }

      .order_status_container {
        text-align: center;

        .order_status {
          border:  3px dashed $orange;
          display: inline-block;
          padding: 20px 20px 20px 20px;

          &.live_order {
            border-color: $green;
          }

          #o_status {
            display:        block;
            color:          $orange;
            font-size:      4rem;
            text-transform: uppercase;
            line-height:    45px;
            font-weight:    bold;

            &.live_order {
              color: $green;
            }
          }
        }
      }
    }
  }
}
</style>
